function reinitializeSizeChartJs() {
  const SizeChartDrawer = document.querySelector("#SizeChartDrawer");
  const popupclose = SizeChartDrawer?.querySelector(".popup-close");
  const overlaySize = document.querySelector(".overlay-size");
  const sizeChartBtns = document.querySelectorAll(".size-chart");

  const toggleSizeChart = (action) => {
    SizeChartDrawer?.classList[action]("active");
    overlaySize?.classList[action]("active");
  };

  sizeChartBtns.forEach((btn) =>
    btn.addEventListener("click", () => toggleSizeChart("add"))
  );

  popupclose?.addEventListener("click", () => toggleSizeChart("remove"));
  overlaySize?.addEventListener("click", () => toggleSizeChart("remove"));
}
reinitializeSizeChartJs();